export function init() {
  $(document).ready(() => {
    const carts = getCart();

    if (!carts || carts.length === 0) {
      localStorage.setItem("carts", JSON.stringify([]));
      $('#checkout').attr('data-cart', false);
      $('.checkout-btn').hide();
    }

    setMiniCartUI();
    setCartUI();
    const deleteBtn = document.querySelectorAll('.delete-btn');
    const increaseBtn = document.querySelectorAll('.increase-btn');
    const decreaseBtn = document.querySelectorAll('.decrease-btn');

    deleteBtn.forEach((button, index) => {
      button.addEventListener('click', () => {
          const carts = getCart();
          const productId = parseInt($(`.product-${index}`).val());
          const productSize = $(`.product-size-${index}`).val();
          const cartItem = $(`#cart-${index}`)
          const productPriceTotal = convertToNumber($(`.product-total-${index}`).html());
          const subTotalEle = $('.subtotal');
          const subtotal = convertToNumber(subTotalEle.html());

          const newCarts = carts.filter(product => !(product.id === productId && product.size === productSize));
          cartItem.remove();
          subTotalEle.html(formatCurrency(subtotal - productPriceTotal) + '₫');
          localStorage.setItem('carts', JSON.stringify(newCarts));
          setMiniCartUI();
          toastr["success"]('Sản phẩm đã ₫ược xóa khỏi giỏ hàng.');
          if (newCarts.length == 0) {
            setCartUI();
          }
      })
    });

    increaseBtn.forEach((button, index) => {
      button.addEventListener('click', () => {
        const carts = getCart();
        let quantityEle = $(`.quantity${index}`);
        const productId = parseInt($(`.product-${index}`).val());
        const productSize = $(`.product-size-${index}`).val();
        const productPrice = parseInt($(`.price-${index}`).val());
        const productPriceTotal = $(`.product-total-${index}`);
        const subTotalEle = $('.subtotal');
        const subtotal = convertToNumber(subTotalEle.html());

        const product = carts.find(product => product.id === productId && product.size === productSize);

        if (product) {
          quantityEle.val(product.quantity + 1)
          product.quantity += 1;
          productPriceTotal.html(formatCurrency(productPrice * product.quantity) + '₫');
          subTotalEle.html(formatCurrency(subtotal + productPrice) + '₫');
          localStorage.setItem('carts', JSON.stringify(carts));
          toastr["success"]('Đã tăng số lượng sản phẩm.');
          setMiniCartUI();
        }

      })
    });

    decreaseBtn.forEach((button, index) => {
      button.addEventListener('click', () => {
        const carts = getCart();
        let quantityEle = $(`.quantity${index}`);
        const productId = parseInt($(`.product-${index}`).val());
        const productSize = $(`.product-size-${index}`).val();
        const productPrice = parseInt($(`.price-${index}`).val());
        const productPriceTotal = $(`.product-total-${index}`);
        const subTotalEle = $('.subtotal');
        const subtotal = convertToNumber(subTotalEle.html());

        if((quantityEle.val()) > 1) {
          const product = carts.find(product => product.id === productId && product.size === productSize);

          if (product) {
            quantityEle.val(product.quantity - 1)
            product.quantity -= 1;
            productPriceTotal.html(formatCurrency(productPrice * product.quantity) + '₫');
            subTotalEle.html(formatCurrency(subtotal - productPrice) + '₫');
            localStorage.setItem('carts', JSON.stringify(carts));
            toastr["success"]('Đã giảm số lượng sản phẩm.');
            setMiniCartUI();
          }
        }
      })
    });
  });
}

export function formatCurrency(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function convertToNumber(money) {
  return parseFloat(money.replace(/[,₫]/g, ''))
}

export function getCart() {
  return JSON.parse(localStorage.getItem('carts'));
}


function setCartUI() {
  const carts = getCart();
  if (carts.length > 0) {
    const listCart = $('.list-cart');
    let subTotal = 0;
    const subTotalEle = $('.subtotal');
    listCart.html('');
    carts.forEach((product, index) => {
      const discounted = product.price * ((100 - product.discount) / 100);
      const total = discounted * product.quantity;
      const productLinked = `${window.location.origin}/san-pham/${product.slug}/${product.id}`;
      subTotal += total;

      listCart.append(`
        <tr class="cart-item" id="cart-${index}">
          <input type="hidden" readonly value="${product.id}" class="product-${index}"/>
          <input type="hidden" readonly value="${product.size}" class="product-size-${index}"/>
          <input type="hidden" readonly value="${discounted}" class="price-${index}"/>
          <td class="item-img">
            <a
              href="${productLinked}">
              <img src="${product.image}" alt="${product.name}" width="100" height="100">
            </a>
          </td>
          <td class="align-middle product-name">
            <a class="name"
               href="${productLinked}">${product.name}</a>
            <div class="py-1">
                ${product.size ? `<p class="py-1 size">Kích cỡ: ${product.size}</p>` : ''}
                ${product.discount ? `<p class="discounter">Giảm giá: ${product.discount}%</p>` : ''}
            </div>
          </td>
          <td class="hide-on-mobile align-middle">
            <p class="price">${formatCurrency(discounted)}₫</p>
            ${product.discount ? `<span class="sale">${formatCurrency(product.price)}₫</span>` : ''}
          </td>
          <td class="align-middle">
            <div class="d-flex align-items-center">
              <div class="quantity ">
                <button class="quantity-button decrease-btn" data-action="decrease"><i
                    class="fa-solid fa-minus"></i></button>
                <input type="text" value="${product.quantity}" class="quantity${index}">
                <button class="quantity-button increase-btn" data-action="increase"><i
                    class="fa-solid fa-plus"></i></button>
              </div>
              <div class="trash delete-btn">
                <i class="fa-solid fa-trash"></i>
              </div>
            </div>
          </td>
          <td class="align-middle">
            <p class="price product-total-${index} d-flex align-items-center">${formatCurrency(total)}₫</p>
          </td>
        </tr>
      `)
    });
    subTotalEle.html(`
      ${formatCurrency(subTotal) + '₫'}
    `);
  } else {
    const cart = $('#cart');
    cart.html(`
      <div class="d-flex flex-column align-items-center">
        <img width="30%" src="${window.location.origin}/assets/images/cart-empty.jpg" alt="Giỏ hàng trống">
        <h4 class="pt-5 font-nunito font-weight-bold">
          Không có sản phẩm nào.
          <a class="text-decoration-underline" href="${window.location.origin}/san-pham/tat-ca">Mua sắm ngay!</a>
        </h4>
      </div>
    `);
  }
}

export function setMiniCartUI() {
  const miniCart = $('.list-minicart');
  const subTotalEle = $('.sub-total-mini-cart');
  const cartTotalItemEle = $('.cart-total-item');
  const carts = getCart();
  let subTotal = 0;

  if (carts.length > 0) {
    miniCart.html('');
    carts.forEach(product => {
      const discounted = product.price * ((100 - product.discount) / 100);
      subTotal += discounted * product.quantity;

      miniCart.append(`
        <div class="minicart-item d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="image-product">
                <img src="${product.image}" alt="${product.name}" width="auto" height="auto">
            </div>
            <div class="item text-left">
              <div class="minicart-name pb-1">
                <p>${product.name}</p>
              </div>
              <span class="price">
                <span class="money">${formatCurrency(discounted)}₫ </span>
                <span class="money">${product.size ? ' / ' + product.size : ''}</span>
              </span>
              <div class="quantity">
                <p >SL: ${product.quantity}</p>
              </div>
            </div>
          </div>
        </div>
      `);
      });

    subTotalEle.html(`
      <label>Tổng</label>: <span><span class="money ">${formatCurrency(subTotal) + '₫'}</span></span>
    `);
    cartTotalItemEle.html(carts.length);
  }
  else {
    const notFoundImg = `${window.location.origin}/assets/images/cart-empty.jpg`;
    miniCart.html('');
    subTotalEle.html(`
      <img width="50%" src="${notFoundImg}" alt="Giỏ hàng trống">
      <p>Giỏ hàng đang trống</p>
    `);
    cartTotalItemEle.html(0);
    $('.checkout-btn').hide();
  }
}
